var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "frequency-modal__time" },
    [
      _c("input-field", {
        attrs: {
          input: "MdsInput",
          type: "time",
          label: "Time",
          value: _vm.time,
          "validator-function": _vm.validTime,
          revalidate: [_vm.repeatType, _vm.startDate, _vm.timezone],
          min: _vm.minimum,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", { runningTime: $event })
          },
          error: function ($event) {
            return _vm.$emit("error", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("mds-combo-box", {
        attrs: {
          label: "Time Zone",
          "data-set": _vm.timezoneDataSet,
          "selected-items": [_vm.selectedTimezone],
        },
        on: {
          input: function ($event) {
            return _vm.setSelectedTimezone($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }